module.exports = __webpack_public_path__ + "static/media/Balancing_tube.729cdf5a.svg";